import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";
import { useEffect, useState } from "react";
import type { FC } from "react";

import {
  normalizeSupportTicketProductionDate,
  normalizeSupportTicketProductQuantity,
} from "./supportTicketProductLabel";
import { SupportTicketProductDialogFields } from "./SupportTicketProductDialogFields";

type Props = {
  productLabel: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (productionDate: Date | null, serialNumber: string | null, quantity: number) => void;
};

export const SupportTicketAddProductSerialDialog: FC<Props> = ({
  productLabel,
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [productionDateDraft, setProductionDateDraft] = useState<Date | null>(null);
  const [serialDraft, setSerialDraft] = useState("");
  const [quantityDraft, setQuantityDraft] = useState(1);

  useEffect(() => {
    if (isOpen) {
      setProductionDateDraft(null);
      setSerialDraft("");
      setQuantityDraft(1);
    }
  }, [isOpen, productLabel]);

  if (!isOpen) {
    return null;
  }

  const confirm = () => {
    onConfirm(
      normalizeSupportTicketProductionDate(productionDateDraft),
      serialDraft.trim() || null,
      normalizeSupportTicketProductQuantity(quantityDraft),
    );
  };

  return (
    <Dialog header={productLabel} onClose={onClose} css={{ width: "22rem" }}>
      <div css={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <SupportTicketProductDialogFields
          quantity={quantityDraft}
          onQuantityChange={setQuantityDraft}
          productionDate={productionDateDraft}
          onProductionDateChange={setProductionDateDraft}
          serialNumber={serialDraft}
          onSerialNumberChange={setSerialDraft}
          onEnterConfirm={confirm}
        />
        <div css={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
          <Button variant="text" onClick={onClose}>
            Anuluj
          </Button>
          <Button onClick={confirm}>Dodaj</Button>
        </div>
      </div>
    </Dialog>
  );
};
